import * as React from 'react'

export const NewlyAvailable = props => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 540 300">
        <path
            fill="#A8C7FA"
            d="m150 0 30 30-30 30-30-30zM210 60l30 30-30 30-30-30zM450 60l30 30-30 30-30-30zM510 120l30 30-30 30-30-30zM450 180l30 30-30 30-30-30zM390 240l30 30-30 30-30-30zM330 180l30 30-30 30-30-30zM90 60l30 30-30 30-30-30z"
        ></path>
        <path fill="#1B6EF3" d="m390 0 30 30-270 270L0 150l30-30 120 120z"></path>
    </svg>
)
